import { Route, Redirect, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useContext } from 'react';
import MenuContext from '~/contexts/menuContext';
import { DesktopNavbar } from '~/components/DesktopNavbar';
import { MobileNavbar } from '~/components/MobileNavbar';
import { apmElastic } from 'helpers/apmElastic';
import { useAuth } from 'react-oidc-context';

const PrivateRouteWrapper = styled.div<{ isMenuOpen }>(
  ({ isMenuOpen }) => `
  padding: 24px 16px;
  @media (min-width: 768px) {
    padding-top: 70px;
    padding-left: ${isMenuOpen ? '270px' : '90px'};
    padding-right: 20px;
  }
`,
);

type PrivateRouteProps = {
  component: React.ElementType
}

export const PrivateWithRedirectRoute = ({ component: Component, ...params }: PrivateRouteProps): JSX.Element => {
  const { isAuthenticated } = useAuth();
  const { menuToogle } = useContext(MenuContext);
  const location = useLocation();
  const path = location.pathname;
  return (
    <>
      <DesktopNavbar />
      <MobileNavbar />
      <PrivateRouteWrapper isMenuOpen={menuToogle}>
        <Route
          {...params}
          render={(props) => {
            if (process.env.REACT_APP_APM_ELASTIC) {
              apmElastic(props.location.pathname);
            }
            return isAuthenticated ? <Component {...props} /> : <Redirect to={`/logout?topage=${path}`} />;
          }}
        />
      </PrivateRouteWrapper>
    </>
  );
};
